export default __webpack_public_path__ + "static/media/epen.9d5dd94b.jpg";